import { Validator, isRequired, validateUrl } from '../../../common/hooks/useFormControls';

export const requiredField = Validator(isRequired, 'This field is required');
const validUrl = Validator(validateUrl, 'Enter a valid URL');
const trimWhitespace = (value) => value.trim();
const includeProtocol = (value) => {
  if (!value.startsWith('http://') && !value.startsWith('https://')) {
    return `https://${value}`;
  }
  return value;
};

const EventListingsFormControls = [
  {
    fieldName: 'title',
    label: 'Event title',
    sanitizers: [trimWhitespace],
    validators: [requiredField],
    value: '',
  },
  {
    fieldName: 'teaser',
    label: 'Description',
    sanitizers: [trimWhitespace],
    value: '',
  },
  {
    fieldName: 'eventType',
    label: 'Event type',
    validators: [requiredField],
    value: '',
  },
  {
    fieldName: 'addressLine1',
    label: 'Address line 1',
    sanitizers: [trimWhitespace],
    value: '',
  },
  {
    fieldName: 'addressLine2',
    label: 'Address line 2',
    sanitizers: [trimWhitespace],
    value: '',
  },
  {
    fieldName: 'city',
    label: 'City',
    value: '',
  },
  {
    fieldName: 'country',
    label: 'Country',
    value: '',
  },
  {
    fieldName: 'stateTerritory',
    label: 'State / Territory',
    value: '',
  },
  {
    fieldName: 'mainUrl',
    label: 'Event URL',
    sanitizers: [trimWhitespace, includeProtocol],
    validators: [requiredField, validUrl],
    value: '',
  },
  {
    fieldName: 'locationType',
    value: 'ONLINE',
  },
  {
    fieldName: 'startDateTime',
    label: 'Event start date and time',
    validators: [requiredField],
    value: '',
    placeholder: 'MM / DD / YYYY –– : –– –– ET',
  },
  {
    fieldName: 'endDate',
    label: 'End date',
    value: '',
    placeholder: 'MM / DD / YYYY',
  },
  {
    description: 'Business or organization that is organizing the event.',
    fieldName: 'presentedBy',
    label: 'Presented by',
    sanitizers: [trimWhitespace],
    validators: [requiredField],
    value: '',
  },
  {
    fieldName: 'photo',
    label: 'Upload event photo',
    value: null,
  },
  {
    fieldName: 'deletePhoto',
    label: 'hidden',
    value: false,
  },
  {
    fieldName: 'publishDate',
    label: 'Schedule publishing date',
    placeholder: 'MM / DD / YYYY',
    validators: [requiredField],
    value: '',
  },
  {
    description: 'Please review and accept our policy to confirm your event listing meets the Events content guidelines.',
    fieldName: 'terms',
    validators: [requiredField],
    value: false,
  },
];

export default EventListingsFormControls;
